/**
 * Для бытовых услуг, общепитов, производства, автосервисов и готового бизнеса
 * нужно добвалять фразу "помещение под".
 */
import { FOfferType } from '../../../utils/offer_type';

export function isPlaceForOfferType(offerType: FOfferType) {
  switch (offerType) {
    case FOfferType.DomesticServices:
    case FOfferType.PublicCatering:
    case FOfferType.Manufacture:
    case FOfferType.AutoService:
    case FOfferType.Business:
      return true;
    default:
      return false;
  }
}
